module.exports = __webpack_public_path__ + "static/BP_(033)C12744.55218289.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/BP_(033)C12744.jpg
// module id = 882
// module chunks = 220747368961260